var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.321,
    height: 45,
    viewBox: "0 0 30.321 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smart_Phone",
    "data-name": "Smart Phone",
    transform: "translate(-102.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M246.105,42.667h-5.738a1.434,1.434,0,1,0,0,2.869h5.738a1.434,1.434,0,1,0,0-2.869Z",
    transform: "translate(-123.665 -37.885)",
    fill: "#1a2b45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M127.668,0H107.454A4.807,4.807,0,0,0,102.4,4.5v36a4.807,4.807,0,0,0,5.054,4.5h20.214a4.807,4.807,0,0,0,5.054-4.5V4.5A4.807,4.807,0,0,0,127.668,0Zm2.527,40.5a2.4,2.4,0,0,1-2.527,2.25H107.454a2.4,2.4,0,0,1-2.527-2.25V4.5a2.4,2.4,0,0,1,2.527-2.25h20.214a2.4,2.4,0,0,1,2.527,2.25Z",
    transform: "translate(0)",
    fill: "#1a2b45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 2.869,
    cy: 2.869,
    r: 2.869,
    transform: "translate(114.692 34.48)",
    fill: "#1a2b45"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 1.434,
    cy: 1.434,
    r: 1.434,
    transform: "translate(111.551 4.782)",
    fill: "#1a2b45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPhone);
export default __webpack_public_path__ + "static/media/Smart Phone.b50604cbf1b641c8d1600b92fd3ac65c.svg";
export { ForwardRef as ReactComponent };